var exports = {
  "n": "inlineCodeTitle__kWY7pC",
};

module.exports = exports;
